export default __webpack_public_path__ + "static/media/DPE_A_WHITE.f8692eee.png";